export default __webpack_public_path__ + "static/media/3.541c1354.jpg";